import React, { createContext } from 'react';

import { GetFiscalYearQuery, MonthYearPeriod, PeriodName, ProductType } from '@neo.tax/shared';

import { SredContextType } from './sred-context-provider.types';

export const SredContext = createContext<SredContextType>({
  fiscalYearId: undefined,
  fiscalYear: undefined,
  periodName: undefined,
  period: undefined,
  product: undefined,
  isNowPastPeriodEndDate: false,
  sredTaxCreditId: undefined,
});

type SredContextProviderProps = {
  children?: React.ReactNode;
  fiscalYearId: string;
  fiscalYear: GetFiscalYearQuery['getFiscalYear'];
  periodName: PeriodName;
  period: MonthYearPeriod;
  product: ProductType;
  isNowPastPeriodEndDate: boolean;
  sredTaxCreditId: string;
};

export const SredContextProvider = ({
  children,
  fiscalYear,
  fiscalYearId,
  isNowPastPeriodEndDate,
  period,
  periodName,
  product,
  sredTaxCreditId,
}: SredContextProviderProps): React.ReactElement => (
  <SredContext.Provider
    value={{ fiscalYearId, fiscalYear, periodName, period, product, isNowPastPeriodEndDate, sredTaxCreditId }}
  >
    {children}
  </SredContext.Provider>
);
